import React, {useState, useEffect} from "react"
import {Button, Table, Form, Input, Row, Col, Modal, Space, message, InputNumber} from "antd";
import {useModel} from "../../../models"

export default function () {
    const [{
        BillModelType, BillTable, BillTableKey, accountList, selectedSupplierBill
    }, {
        setBillModelType, setBillTable, setBillTableKey, BillFlat, setTabsKey, loadSupplierAccountList
    }] = useModel('supplierBill')

    const [form] = Form.useForm();
    const lineAccount = accountList.filter((item) => {
        if (item.accountType === "009001") {
            return item
        }
    })
    const [newPrice, setNewPrice] = useState(0)

    useEffect(() => {
        let {remainingAmount} = lineAccount[0]
        let sumPrice = BillTable.reduce((total, newItem) => {
            return parseFloat(total) + parseFloat(newItem.amountReceivable);
        }, 0)
        let resPrice = remainingAmount - sumPrice
        setNewPrice(resPrice)
        form.setFieldsValue({
            flatBill: "授信账户",
            surplusSum: remainingAmount,
            present: sumPrice.toFixed(2),
            flatBalance: resPrice.toFixed(2),
            omitAmount: 0.00,
        })

    }, [BillModelType, BillTable, accountList])

    const columns = [
        {
            title: '序号',
            render: (text, record, index) => `${index + 1}`
        },
        {
            title: '单据编号',
            dataIndex: 'documentNumber',
            key: 'documentNumber',
        },
        {
            title: '单据类型',
            dataIndex: 'documentType',
            key: 'documentType',
        },
        {
            title: '单据金额',
            dataIndex: 'amountReceivable',
            key: 'amountReceivable',
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            render: (text, record) => (
                <Space size="middle">
                    <Button danger key={record.id} onClick={() => delTableItem(text, record)}>移除</Button>
                </Space>
            ),
        },
    ];
    const delTableItem = (text, record) => {
        let {id} = record
        let newTable = BillTable.filter((item, index) => {
            if (item.id !== id) {
                return item
            }
        })
        let newTableKey = BillTableKey.filter((item, index) => {
            if (item !== id) {
                return item
            }
        })
        setBillTable(newTable)
        setBillTableKey(newTableKey)

    }
    const handleOk = async () => {

        if (newPrice < 0) {
            return message.error('剩余金额不足，无法进行平账操作');
        }
        if (BillTable.length === 0) {
            return setBillModelType(!BillModelType)
        }
        let {omitAmount, remarks} = form.getFieldValue()
        let newBillIDList = []
        BillTable.forEach((item) => {
            newBillIDList.push({"id": item.id})
        })
        let data = {
            relationId: selectedSupplierBill.id,
            omitAmount,
            remarks: remarks,
            detailed: newBillIDList
        }
        await BillFlat({data});
        loadSupplierAccountList({showMsg: false, data: selectedSupplierBill ? selectedSupplierBill.id : null})
        setBillTable([]);
        setBillTableKey([]);
        setBillModelType(!BillModelType);
        setTabsKey("balanceList")

    }
    const handleCancel = () => {
        setBillModelType(!BillModelType);
    }
    return (
        <Modal
            title="平账操作"
            visible={BillModelType}
            onOk={handleOk}
            onCancel={handleCancel}
            width={1000}

        >
            <div className="billModelBox">
                <Form
                    form={form}
                    layout="horizontal"
                    labelCol={{span: 6}}
                    onValuesChange={(el) => {
                        if (el["omitAmount"]) {
                            let omitAmount = parseFloat(el["omitAmount"]);
                            if (isNaN(omitAmount)) {
                                omitAmount = 0.00;
                            }
                            form.setFieldsValue({flatBalance: (newPrice + omitAmount).toFixed(2)});
                        }
                    }}
                >
                    <Row gutter={[16, 8]}>
                        <Col span={12}>
                            <Form.Item
                                name="flatBill"
                                label="平账账户"
                            >
                                <Input placeholder="平账账户" disabled/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="surplusSum"
                                label="账户剩余金额"
                            >
                                <Input placeholder="账户剩余金额" disabled/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 8]}>
                        <Col span={12}>
                            <Form.Item
                                name="present"
                                label="本次平账总额"
                            >
                                <Input placeholder="本次平账总额" disabled/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="flatBalance"
                                label="平账后余额"
                            >
                                <Input placeholder="平账后余额" disabled/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 8]}>
                        <Col span={12}>
                            <Form.Item
                                name="omitAmount"
                                label="抹零金额"
                                // rules={[{required: false, type: "number", message: '必须输入数字',}]}
                            >
                                <InputNumber placeholder="抹零金额" style={{width: "100%"}}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="remarks"
                                label="备注"
                            >
                                <Input placeholder="备注"/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <Table
                    columns={columns}
                    dataSource={BillTable}
                    rowKey="id"
                />
            </div>
        </Modal>
    )
}
